export async function isReallyOnline() {
  try {
    const res = await fetch('/favicon.ico', { method: 'HEAD', cache: 'no-store' })
    // console.log('isReallyOnline: ', res.ok)
    return res.ok
  } catch {
    return false
  }
}
